import { render, staticRenderFns } from "./ComplianceModal.vue?vue&type=template&id=6a221095"
import script from "./ComplianceModal.vue?vue&type=script&lang=js"
export * from "./ComplianceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports